var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInicioColoridoCria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.23 23.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #367E20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.83,15.88c-.58.82-1.13,1.61-1.71,2.43-.58-.83-1.13-1.61-1.71-2.43h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.83,23.09h-3.41c.58-.82,1.13-1.6,1.71-2.42.57.81,1.13,1.6,1.71,2.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.29,19.49c-.7.99-1.42,1.94-2.06,2.96-.33.53-.71.78-1.31.66-.1-.02-.2,0-.33,0v-7.23h1.08c.05,0,.11.06.15.11.82,1.16,1.64,2.33,2.47,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.64,15.87v7.24h-1c-.08,0-.19-.07-.24-.14-.78-1.1-1.56-2.21-2.34-3.31-.09-.12-.08-.2,0-.32.78-1.09,1.55-2.19,2.33-3.28.06-.09.21-.16.32-.17.3-.02.61,0,.94,0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.86,13.51c0-.15-.03-.3-.08-.44-.58-1.65-1.17-3.31-1.77-4.95-.05-.13-.14-.27-.25-.35-2.14-1.54-4.3-3.07-6.44-4.6-.15-.11-.24-.1-.39,0-2.15,1.54-4.3,3.06-6.44,4.6-.11.08-.21.22-.25.35-.6,1.65-1.18,3.3-1.77,4.95-.04.12-.07.26-.07.39v9.65h2.86v-7.74c0-.62.24-.87.85-.87h10.08c.59,0,.83.25.83.85v7.74h2.85c0-.09.01-.18.01-.27v-9.31h-.02Zm-4.97-1.37h-7.53c-.44,0-.73-.29-.72-.7,0-.39.29-.66.72-.67h.68v-2.63c0-.63.23-.86.84-.86h4.48c.62,0,.85.23.85.85v2.64h.67c.44,0,.73.29.72.69,0,.39-.29.67-.72.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.23,12.48c-.34,0-.66-.01-.98,0-.19,0-.27-.05-.34-.24-.57-1.62-1.15-3.23-1.72-4.85-.09-.26-.24-.46-.46-.62-2.37-1.68-4.73-3.36-7.09-5.05-.42-.3-.62-.3-1.04,0-2.36,1.68-4.71,3.36-7.07,5.03-.24.17-.4.37-.5.66-.56,1.61-1.15,3.21-1.71,4.82-.06.18-.14.26-.33.24-.32-.02-.63,0-.99,0,.03-.12.06-.21.09-.31.67-1.84,1.34-3.69,2.02-5.53.05-.14.16-.28.28-.37C5.23,4.2,8.08,2.14,10.92.08c.14-.1.24-.11.39,0,2.85,2.07,5.71,4.13,8.56,6.19.09.07.18.17.22.27.71,1.92,1.41,3.84,2.11,5.77.01.03.01.07.03.15v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.84,8.67h-3.45v2.08h3.45v-2.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicioColoridoCria);
export default __webpack_public_path__ + "static/media/inicio_colorido_cria.cd27bd97ea9f0bf9499d3c2235a594bd.svg";
export { ForwardRef as ReactComponent };